import { FetchService } from "./fetch.service";

export const fetchService = new FetchService();